import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
const EventArea = React.lazy(() => import('./EventArea'))
const SocialPreview = React.lazy(() => import('./SocialPreview'))
const path = location.pathname.replace(/\/$/, '')

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {path === '/social/preview' ? (
      <React.Suspense fallback={<p>Loading preview…</p>}>
        <SocialPreview />
      </React.Suspense>
    ) : path === '/events' ? (
      <React.Suspense fallback={<p>Loading…</p>}>
        <EventArea />
      </React.Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>,
)
